export const PUSH = 'ROUTER/PUSH'
export const REDIRECT = 'ROUTER/REDIRECT'
export const REPLACE = 'ROUTER/REPLACE'
export const GO = 'ROUTER/GO'
export const GO_BACK = 'ROUTER/GO_BACK'
export const GO_FORWARD = 'ROUTER/GO_FORWARD'
export const LOCATION_CHANGE = 'ROUTER/LOCATION_CHANGE'
export const ON_ENTER = 'ROUTER/ON_ENTER'



// WEBPACK FOOTER //
// ./src/router/constants.ts